@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.paging-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;
  background-color: @paging-control--background-color;
  align-items: center;
  height: 42px;
  font-size: 13px;
  color: var(--grey-900);
}

.paging-controls {
  display: flex;
  justify-content: flex-end;
}

.number-selected {
  display: inline-block;
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid @paging-control--number-selected--border-color;
  line-height: 30px;
}

.paging-buttons {
  padding-right: 15px;
  border-right: 1px solid @paging-control--paging-buttons--border-color;
  display: flex;
  align-items: center;
}

.paging-back,
.paging-forward {
  position: relative;
}

.paging-current-total {
  padding: 0 5px;
}

.paging-record-count {
  padding-left: 15px;
}

.button-pager {
  height: 25px;
  width: 15px;
  cursor: pointer;
  position: relative;
  > svg {
    height: 25px;
    width: 25px;
    vertical-align: middle;
    position: relative;
    left: 50%;
    transform: translateX(-50%) scale(0.35);
  }
  &:disabled {
    cursor: default;

    > svg {
      fill: @paging-control--button-pager--disabled--fill-color;
    }
  }
}

.page-jump-input {
  width: 40px;
  text-align: right;
  margin: 0 4px;
}

.per-page-wrap {
  padding-left: 10px;
}

.paging-record-count-input {
  > button {
    background: @paging-control--paging-record-count-input-button--background-color;
    border-top: 1px solid @paging-control--paging-record-count-input-button--border-color;
    border-bottom: 1px solid @paging-control--paging-record-count-input-button--border-color;
  }
}

.count-container,
.select-all-container {
  display: flex;
  align-items: center;
}
